/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";

// Vision UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Dashboard layout components
import BenefitsCard from "./components/BenefitsCard";
import TransactionsTable from "./components/TransactionsTable";
import StepByStepGuide from "./components/StepByStepGuide";
import SuportUsCard from "./components/SuportUsCard";

// Web3ui
import AuthUser from "web3ui/AuthUser";

// Moralis
import { useMoralis } from "react-moralis";

function SuportChannel() {
  // use moralis to connect wallet
  const { isInitialized, isAuthenticated, account, Moralis } = useMoralis();
  const [adminWallets, setAdminWallets] = useState([]);

  useEffect(() => {
    getWallets();
  }, []);

  const getWallets = async () => {
    try {
      const getTeamWallets = Moralis.Object.extend("TeamWallets");
      const query = new Moralis.Query(getTeamWallets);
      const results = await query.find();
      setAdminWallets(results[0].attributes.adminWallets);
    } catch (err) {
      return Promise.reject(err);
    }
  };

  let isAdminWallet;

  if (account) {
    isAdminWallet = adminWallets.includes(account);
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox py={3}>
        <VuiBox py={3}>{isInitialized && isAuthenticated && account ? <AuthUser /> : <></>}</VuiBox>

        <VuiBox mb={3}>
          <Grid container spacing="18px">
            <Grid item xs={12} lg={6} xl={6}>
              <SuportUsCard />
            </Grid>
            <Grid item xs={12} lg={6} xl={6}>
              <StepByStepGuide />
            </Grid>
          </Grid>
        </VuiBox>

        <VuiBox mb={3}>
          <Grid container>
            <Grid item xs={12} lg={12} xl={12}>
              <BenefitsCard />
            </Grid>
          </Grid>
        </VuiBox>

        <VuiBox mb={3}>
          {isAdminWallet ? (
            <Grid container>
              <Grid item xs={12} lg={12} xl={12}>
                <TransactionsTable />
              </Grid>
            </Grid>
          ) : (
            <></>
          )}
        </VuiBox>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default SuportChannel;
